import { useApiClient } from '@m43/core';
import { useQuery } from '@tanstack/react-query';
import { CadSearchResource, EventSearchForm } from '@mark43/cad-api';
import { useEventSearchResultsPaginationContext } from './event-search-results-pagination-provider';
import { useHandleSearchResponse } from '../search-windows/use-handle-search-response';
import { useEventSearchSortContext } from './event-search-sort-provider';

export function useSearchEventsQuery(
    tabId: number,
    eventSearchForm: EventSearchForm,
    savedSearchId?: number
) {
    const pagination = useEventSearchResultsPaginationContext();
    const sort = useEventSearchSortContext();
    const apiClient = useApiClient();
    const handleSearchResponse = useHandleSearchResponse(pagination);
    return useQuery(
        [
            'event-search-results',
            tabId,
            pagination.itemOffset,
            pagination.itemsPerPage,
            sort.sortByValue.value,
            sort.directionValue.value,
        ] as const,
        ({ queryKey }) => {
            return apiClient
                .request<CadSearchResource.EventSearch>({
                    method: 'POST',
                    url: 'cad_search/event',
                    data: {
                        eventSearchForm,
                        from: queryKey[2],
                        size: queryKey[3],
                        sortKey: queryKey[4],
                        sortType: queryKey[5],
                    },
                })
                .then((resp) => {
                    const eventSearchResponse = resp.data.data;
                    handleSearchResponse(eventSearchResponse?.totalCount, queryKey[2]);
                    return eventSearchResponse;
                });
        },
        {
            enabled: !savedSearchId,
        }
    );
}
